import React, {Component} from "react";

import {SyncLoader} from "react-spinners";

import css from "./SisLoader.module.scss";

class SisLoader extends Component {
	render() {
		return (
			<>
				{/*<div id={this.props.id} className={css.loaderWrap}>
					<div className={css.loader}></div>
					<div className={css.loadingText}>Loading</div>
				</div>*/}
				<div className={css.loaderWrap}>
				<h3>잠시만 기다려주세요.</h3>
      			<SyncLoader />
				  </div>
			</>
		);
	}
}

export default SisLoader;
